import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmailVerificationNotificationApi {
  constructor(private _http: HttpClient) { }

  resend$(id: string) {
    return this._http.put<{ success: boolean }>(
      `/api/user/${id}/send-verification-email`,
      {}
    );
  }

}
